import { lazy } from "react";
const MarketingPage = lazy(() => import("@/pages/MarketingPage"));
const MarketingFeaturesPage = lazy(
  () => import("@/pages/marketing/MarketingFeaturesPage"),
);
const MarketingPlansPage = lazy(
  () => import("@/pages/marketing/MarketingPlansPage"),
);
const MarketingContactPage = lazy(
  () => import("@/pages/marketing/MarketingContactPage"),
);
const MarketingAboutPage = lazy(
  () => import("@/pages/marketing/MarketingAboutPage"),
);
const LoginPage = lazy(() => import("@/pages/LoginPage"));
const PlatformLoginPage = lazy(() => import("@/pages/platform/PlatformLoginPage"));
const PlatformDashboardPage = lazy(() => import("@/pages/platform/PlatformDashboardPage"));
const PlatformCustomersPage = lazy(() => import("@/pages/platform/PlatformCustomersPage"));
const PlatformCustomerCreatePage = lazy(() => import("@/pages/platform/PlatformCustomerCreatePage"));
const PlatformCustomerDetailPage = lazy(() => import("@/pages/platform/PlatformCustomerDetailPage"));
const PlatformRolesPage = lazy(() => import("@/pages/platform/PlatformRolesPage"));
const PlatformOperatorsPage = lazy(() => import("@/pages/platform/PlatformOperatorsPage"));
const CustomerPermissionsPage = lazy(() => import("@/pages/customer/CustomerPermissionsPage"));
const SettingsPage = lazy(() => import("@/pages/SettingsPage"));
const GroupDashboardPage = lazy(
  () => import("@/pages/phase1/GroupDashboardPage"),
);
const CompanyDashboardPage = lazy(
  () => import("@/pages/phase1/CompanyDashboardPage"),
);
const ControlTowerPage = lazy(() => import("@/pages/phase1/ControlTowerPage"));
const OrdersListPage = lazy(() => import("@/pages/phase1/OrdersListPage"));
const OrderCreatePage = lazy(() => import("@/pages/phase1/OrderCreatePage"));
const OrderDetailPage = lazy(() => import("@/pages/phase1/OrderDetailPage"));
const VehicleBoardPage = lazy(() => import("@/pages/phase1/VehicleBoardPage"));
const ContainerPlannerPage = lazy(
  () => import("@/pages/phase1/ContainerPlannerPage"),
);
const DispatchSheetPage = lazy(
  () => import("@/pages/phase1/DispatchSheetPage"),
);
const ConflictsPage = lazy(() => import("@/pages/phase1/ConflictsPage"));
const TripsListPage = lazy(() => import("@/pages/phase1/TripsListPage"));
const TripDetailPage = lazy(() => import("@/pages/phase1/TripDetailPage"));
const PodInboxPage = lazy(() => import("@/pages/phase1/PodInboxPage"));
const InvoiceQueuePage = lazy(() => import("@/pages/phase1/InvoiceQueuePage"));
const InvoiceDetailPage = lazy(
  () => import("@/pages/phase1/InvoiceDetailPage"),
);
const PodDetailPage = lazy(() => import("@/pages/phase1/PodDetailPage"));
const LedgerPage = lazy(() => import("@/pages/phase1/LedgerPage"));
const AgeingPage = lazy(() => import("@/pages/phase1/AgeingPage"));
const AccessAdminPage = lazy(() => import("@/pages/phase1/AccessAdminPage"));
const CollectionDashboardPage = lazy(
  () => import("@/pages/phase1/CollectionDashboardPage"),
);
const ReceiptEntryPage = lazy(() => import("@/pages/phase1/ReceiptEntryPage"));
const TripExceptionsPage = lazy(
  () => import("@/pages/phase1/TripExceptionsPage"),
);
const TripHistoryPage = lazy(() => import("@/pages/phase1/TripHistoryPage"));
const TripClosurePage = lazy(() => import("@/pages/phase1/TripClosurePage"));
const WhatsAppMockPage = lazy(() => import("@/pages/phase1/WhatsAppMockPage"));
const CollectionFollowUpPage = lazy(
  () => import("@/pages/phase1/CollectionFollowUpPage"),
);
const BillingAdjustmentsPage = lazy(
  () => import("@/pages/phase1/BillingAdjustmentsPage"),
);
const CompanyMasterPage = lazy(
  () => import("@/pages/masters/CompanyMasterPage"),
);
const GlobalCustomerMasterPage = lazy(
  () => import("@/pages/masters/GlobalCustomerMasterPage"),
);
const ReferenceMastersPage = lazy(
  () => import("@/pages/masters/ReferenceMastersPage"),
);
const CompanyLetterheadSettingsPage = lazy(
  () => import("@/pages/admin/CompanyLetterheadSettingsPage"),
);
const OfficeTasksPage = lazy(() => import("@/pages/phase2/OfficeTasksPage"));
const TaskDetailPage = lazy(() => import("@/pages/phase2/TaskDetailPage"));
const DepartmentBoardPage = lazy(
  () => import("@/pages/phase2/DepartmentBoardPage"),
);
const OfficeApprovalsPage = lazy(
  () => import("@/pages/phase2/OfficeApprovalsPage"),
);
const ApprovalDetailPage = lazy(
  () => import("@/pages/phase2/ApprovalDetailPage"),
);
const OfficeFollowUpsPage = lazy(
  () => import("@/pages/phase2/OfficeFollowUpsPage"),
);
const FollowUpDetailPage = lazy(
  () => import("@/pages/phase2/FollowUpDetailPage"),
);
const RemindersPage = lazy(() => import("@/pages/phase2/RemindersPage"));
const EscalationsPage = lazy(() => import("@/pages/phase2/EscalationsPage"));
const EscalationRulesPage = lazy(
  () => import("@/pages/phase2/EscalationRulesPage"),
);
const CommunicationTemplatesPage = lazy(
  () => import("@/pages/phase1/CommunicationTemplatesPage"),
);
const ClientFeedbackPage = lazy(
  () => import("@/pages/phase5/ClientFeedbackPage"),
);
const ReportLibraryPage = lazy(
  () => import("@/pages/phase5/ReportLibraryPage"),
);
const ScheduledExportsPage = lazy(
  () => import("@/pages/phase5/ScheduledExportsPage"),
);
const WorkflowImprovementsPage = lazy(
  () => import("@/pages/phase5/WorkflowImprovementsPage"),
);
const AiRecommendationsPage = lazy(
  () => import("@/pages/phase5/AiRecommendationsPage"),
);
const PromiseToPayPage = lazy(() => import("@/pages/phase2/PromiseToPayPage"));
const CollectorPerformancePage = lazy(
  () => import("@/pages/phase2/CollectorPerformancePage"),
);
const DocumentRepositoryPage = lazy(
  () => import("@/pages/phase2/DocumentRepositoryPage"),
);
const FleetDriversPage = lazy(() => import("@/pages/phase3/FleetDriversPage"));
const DriverDetailPage = lazy(() => import("@/pages/phase3/DriverDetailPage"));
const FleetUtilizationPage = lazy(
  () => import("@/pages/phase3/FleetUtilizationPage"),
);
const FleetVehiclesPage = lazy(
  () => import("@/pages/phase3/FleetVehiclesPage"),
);
const VehicleDetailPage = lazy(
  () => import("@/pages/phase3/VehicleDetailPage"),
);
const FleetFuelPage = lazy(() => import("@/pages/phase3/FleetFuelPage"));
const FleetRoutePerformancePage = lazy(
  () => import("@/pages/phase3/FleetRoutePerformancePage"),
);
const WorkshopMaintenancePage = lazy(
  () => import("@/pages/phase4/WorkshopMaintenancePage"),
);
const WorkshopMaintenanceCreatePage = lazy(
  () => import("@/pages/phase4/WorkshopMaintenanceCreatePage"),
);
const WorkshopMaintenanceDetailPage = lazy(
  () => import("@/pages/phase4/WorkshopMaintenanceDetailPage"),
);
const WorkshopJobCardsPage = lazy(
  () => import("@/pages/phase4/WorkshopJobCardsPage"),
);
const WorkshopJobCardDetailPage = lazy(
  () => import("@/pages/phase4/WorkshopJobCardDetailPage"),
);
const WorkshopServiceSchedulePage = lazy(
  () => import("@/pages/phase4/WorkshopServiceSchedulePage"),
);
const WorkshopInventoryPage = lazy(
  () => import("@/pages/phase4/WorkshopInventoryPage"),
);
const WorkshopBreakdownsPage = lazy(
  () => import("@/pages/phase4/WorkshopBreakdownsPage"),
);
const WorkshopBreakdownDetailPage = lazy(
  () => import("@/pages/phase4/WorkshopBreakdownDetailPage"),
);
const WorkshopVendorBillsPage = lazy(
  () => import("@/pages/phase4/WorkshopVendorBillsPage"),
);
const WorkshopVendorBillDetailPage = lazy(
  () => import("@/pages/phase4/WorkshopVendorBillDetailPage"),
);
const WorkshopDowntimePage = lazy(
  () => import("@/pages/phase4/WorkshopDowntimePage"),
);
const WorkshopEstimatesPage = lazy(
  () => import("@/pages/phase4/WorkshopEstimatesPage"),
);
const WorkshopEstimateDetailPage = lazy(
  () => import("@/pages/phase4/WorkshopEstimateDetailPage"),
);
const WorkshopEscalationsPage = lazy(
  () => import("@/pages/phase4/WorkshopEscalationsPage"),
);
const WorkshopReportsPage = lazy(
  () => import("@/pages/phase4/WorkshopReportsPage"),
);
export {
  AccessAdminPage,
  AgeingPage,
  AiRecommendationsPage,
  ApprovalDetailPage,
  BillingAdjustmentsPage,
  CollectionDashboardPage,
  CollectionFollowUpPage,
  ClientFeedbackPage,
  CollectorPerformancePage,
  CommunicationTemplatesPage,
  CompanyDashboardPage,
  CompanyLetterheadSettingsPage,
  CompanyMasterPage,
  ConflictsPage,
  ContainerPlannerPage,
  ControlTowerPage,
  DepartmentBoardPage,
  DispatchSheetPage,
  DocumentRepositoryPage,
  DriverDetailPage,
  EscalationRulesPage,
  EscalationsPage,
  FleetDriversPage,
  FleetFuelPage,
  FleetRoutePerformancePage,
  FleetUtilizationPage,
  FleetVehiclesPage,
  FollowUpDetailPage,
  GlobalCustomerMasterPage,
  GroupDashboardPage,
  InvoiceDetailPage,
  InvoiceQueuePage,
  LedgerPage,
  LoginPage,
  CustomerPermissionsPage,
  PlatformCustomerCreatePage,
  PlatformCustomerDetailPage,
  PlatformCustomersPage,
  PlatformDashboardPage,
  PlatformLoginPage,
  PlatformOperatorsPage,
  PlatformRolesPage,
  MarketingAboutPage,
  MarketingContactPage,
  MarketingFeaturesPage,
  MarketingPage,
  MarketingPlansPage,
  OfficeApprovalsPage,
  OfficeFollowUpsPage,
  OfficeTasksPage,
  OrderCreatePage,
  OrderDetailPage,
  OrdersListPage,
  PodDetailPage,
  PodInboxPage,
  PromiseToPayPage,
  ReceiptEntryPage,
  ReferenceMastersPage,
  RemindersPage,
  ReportLibraryPage,
  ScheduledExportsPage,
  SettingsPage,
  TaskDetailPage,
  TripClosurePage,
  TripDetailPage,
  TripExceptionsPage,
  TripHistoryPage,
  TripsListPage,
  VehicleBoardPage,
  VehicleDetailPage,
  WhatsAppMockPage,
  WorkflowImprovementsPage,
  WorkshopBreakdownDetailPage,
  WorkshopBreakdownsPage,
  WorkshopDowntimePage,
  WorkshopEscalationsPage,
  WorkshopEstimateDetailPage,
  WorkshopEstimatesPage,
  WorkshopInventoryPage,
  WorkshopJobCardDetailPage,
  WorkshopJobCardsPage,
  WorkshopMaintenanceCreatePage,
  WorkshopMaintenanceDetailPage,
  WorkshopMaintenancePage,
  WorkshopReportsPage,
  WorkshopServiceSchedulePage,
  WorkshopVendorBillDetailPage,
  WorkshopVendorBillsPage,
};
